export const requireMessage = "regex.required";
export const shouldNumber = "regex.number";
export const positiveNumber = "regex.positiveNumber";
export const min5Message = "regex.min5";
export const min3Message = "regex.min3";
export const length10Message = "regex.length10";
export const passwordMessage = "regex.password";
export const confirmPasswordMessage = "regex.confirmPassword";
export const emailMessage = "regex.email";
export const phoneMessage = "regex.phone";
export const telegramMessage = "regex.telegram";
export const plateNumberMessage = "regex.numberPlate";
export const branchCodeMessage = "regex.branchCode";
